import { Component, OnInit } from '@angular/core';
import { User, UserProfile } from '../shared/models/user';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../core/services/authentication/authentication.service';
import { AuthorizationService } from '../core/services/authorization/authorization.service';
import { ClientService } from '../core/services/client/client.service';
import { SplunkService } from '../core/services/splunk/splunk.service';
import { DatePipe } from '@angular/common';
import { ConfigService } from '../core/services/config.service';
import { OidcClientService } from '../core/services/oidc-client-ts/oidc-client.service';
import { LoaderService } from '../core/services/loader/loader.service';
import { WaiversService } from '../waiver-management/services/waivers/waivers.service';
import { StorageService } from '../waiver-management/services/storage/storage.service';


@Component({
    selector: 'app-auth-callback',
    templateUrl: './auth-callback.component.html',
    styleUrls: ['./auth-callback.component.scss'],
    standalone: false
})
export class AuthCallbackComponent implements OnInit {
  code: string;
  public user: User = null;
  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private loaderService: LoaderService,
    private authorizationService: AuthorizationService,
    private clientService: ClientService,
    private splunkService: SplunkService,
    private configService: ConfigService,
    private oidcClientService: OidcClientService,
    private datepipe: DatePipe,
    private waiversService: WaiversService,
    private storageService: StorageService
  ) {
  }


  ngOnInit() {
    if (window.location.pathname === '/silent-refresh') {
      return;
    }
    this.loaderService.show();
    this.oidcClientService.userManager.signinCallback().then((data) => {
      this.user = this.authorizedCallback(data);
      if (this.user) {
        this.authService.setUserStorage(this.user);
        this.getPcUser();
      }

    }).catch(err => {
      // for invalid state or any errors, redirecting to dashboard if user exists it will load home page or else redirects to login.
      this.router.navigate(['/dashboard']);
      this.loaderService.hide();
    });
  }
  getPcUser() {
    this.authorizationService.getUserDetails(this.user.uuid)
      .subscribe({
        next: (response) => {
         // const roles = response['Roles'];
          const EncRoles = response['EncRoles'];
          const roles = this.getRolesFromToken(EncRoles);
         // const rolesCommaSeparated = roles.join(',');
          // Use StorageService to set encryptedRoles
          localStorage.setItem('encryptedRoles', EncRoles);
          this.storageService.setItem('encryptedRoles', EncRoles);
          if (response && response.UserStatus === 'Active') {
            this.authService.isUserActiveInPC = true;
            this.user.profile.UserType = response.UserType;
            this.user.profile.Roles = roles ;// response.Roles;
            this.user.profile.UserName = response.UserName;
            this.user.profile.UserId = response.UserId;
            this.user.profile.FirstName = response?.FirstName;
            this.user.profile.LastName = response?.LastName;
            this.authService.setUserStorage(this.user);
            this.getUserPermissions();
          } else {
            this.authService.isUserActiveInPC = false;
            this.authService.clearUserStorage();
            this.oidcClientService.logout();
            this.loaderService.hide();
          }
        },
        error: (error) => console.error(`error : ${error}`),
        complete: () => {}
      });
  }

  getUserPermissions() {
    this.authorizationService.getPermissions(this.user.profile.UserName, this.user.profile.Roles)
      .subscribe(response => {
        this.user.profile.Permissions = response.Permissions;
        if (this.user.profile.Roles.indexOf('rWaiver Management Internal Verification Admin') > -1) {
          this.waiversService.filterThirdPartyVerificationEnabledClients(response.AllowedClients);
        }
        else {
          this.clientService.createClientList(response.AllowedClients);
        }
        this.authService.setUserStorage(this.user);
        this.router.navigate(['/dashboard']);
      });
  }

  authorizedCallback(result: any) {
    const user = new User();
    const decodedToken = this.authService.getDecodedAccessToken(result.id_token);
    user.uuid = decodedToken?.sub;
    user.profile = new UserProfile();
    user.profile.Email = decodedToken.email;
    user.profile.FirstName = '';
    user.profile.LastName = '';
    user.profile.Permissions = [];
    user.profile.UserName = decodedToken?.preferred_username;
    user.profile.UserId = '';
    user.profile.UserType = '';
    return user;
  }

  /**
   * Extracts roles from a JWT token
   * @param token - The JWT token string to decode
   * @returns Array of roles from the token, or empty array if no roles found
   */
  getRolesFromToken(token: string): string[] {
    try {
      const decodedToken = this.authService.getDecodedAccessToken(token);
      
      // Check common role claim names used in JWT tokens
      if (decodedToken?.role) {
        // If role is a string, convert to array
        return Array.isArray(decodedToken.role) ? decodedToken.role : [decodedToken.role];
      }
      
      if (decodedToken?.roles) {
        return Array.isArray(decodedToken.roles) ? decodedToken.roles : [decodedToken.roles];
      }
      
      // Check for Microsoft-style role claims
      if (decodedToken?.['http://schemas.microsoft.com/ws/2008/06/identity/claims/role']) {
        const roles = decodedToken['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
        return Array.isArray(roles) ? roles : [roles];
      }
      
      return [];
    } catch (error) {
      console.error('Error decoding JWT token:', error);
      return [];
    }
  }
  logUserAuthentication(user: User): void {
    // splunk log for user login
    try {
      if (user)
        this.splunkService.log('PC_User_Log', {
          request: 'Partnercenter User Login',
          response: {
            userNameText: `${user.profile?.FirstName} ${user.profile?.LastName}`,
            userName: user.profile?.UserName,
            dateTime: this.datepipe.transform(new Date(), "MM/dd/yyyy hh:mm:ss a zzzz", this.configService.timeZone)
          }
        }, user.profile?.UserId);
    } catch (error) {
      console.log('Login-Splunk-Error', error)
    }
  }
}
